import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormHelperService } from '../core/services/form-helper.service';
import { FilterItemsService } from "../reports";
import { AssetsService } from './asset.services';
import { DropdownValue } from '../shared/dropdown.model';
import { DropdownComponent } from '..';
import { DatePipe } from '@angular/common'
import { ClaimsService } from '../core/services';

@Component({
    moduleId: module.id,
    selector: 'asset-modal',
    templateUrl: 'asset-modal.component.html'
})

export class AssetModalComponent implements OnInit {
    isSambaAdmin: boolean = false;

    publisherId: number = 0;
    publisherValues: Array<DropdownValue> = [];

    assetForm: FormGroup;
    isSaving: boolean = false;
    isLoading: boolean = false;

    file: File;
    showUploadError: boolean = false;
    showUploadFileSizeExceededError: boolean = false;

    private readonly modalId = "#assetModal";

    @ViewChild('publisherDropdown') publisherDropdown: DropdownComponent;

    @Output() assetCreated: EventEmitter<any> = new EventEmitter<Event>();

    constructor(private formBuilder: FormBuilder,
        private formHelperService: FormHelperService,
        private assetsService: AssetsService,
        private filterItemsService: FilterItemsService,
        private claimsService: ClaimsService,
        public datePipe: DatePipe) {
    }

    ngOnInit() {
        this.isSambaAdmin = this.claimsService.getUserTypeId() === 1;

        this.assetForm = this.formBuilder.group({
            nameField: ['', [Validators.required]],
            videoField: ['', [Validators.required]],
        });

        this.filterItemsService.getPublishers().forEach(element => {
            this.publisherValues.push(new DropdownValue(element.value, element.label));
        });
    }

    onPublisherValueChanged(item) {
        this.publisherId = item.value;  
    }

    onSaveChanges(event: any) {
        if (this.file.size > 200 * 1024 * 1024) //200MB
            this.showUploadFileSizeExceededError = true;
        else this.showUploadFileSizeExceededError = false;

        if (!this.assetForm.valid)
            return;

        this.isSaving = true;

        this.assetsService.createAsset(this.assetForm.value.nameField, this.publisherId, this.file)
            .subscribe(() => {
                this.assetCreated.emit();
                $(this.modalId).modal('hide');
            }, (error: any) => { this.isSaving = false; }, () => { this.isSaving = false; });
    }

    showCreateAsset() {
        this.isSaving = false;
        this.assetForm.reset();
        this.showUploadError = false;
        this.showUploadFileSizeExceededError = false;

        if (this.publisherDropdown)
            this.publisherDropdown.resetSelection();
        this.publisherId = 0;

        $(this.modalId).modal('show');
    }

    onUploadChanged(event): void {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            this.file = fileList[0];
            this.showUploadError = false;
        }
        else {
            this.file = null;
            this.showUploadError = true;
        }
    }

    showErrorMessage(controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(this.assetForm, controlName, validator);
    }

    onClose(event) {
        this.publisherId = 0;
        this.isLoading = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/assets/asset-modal.component.ts